import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../lib/request'

export const archiveMessage = createAsyncThunk(
  'messageArchive/archive',
  async ({ messageIds, reason }, { rejectWithValue }) => {
    try {
      const ids = (Array.isArray(messageIds) ? messageIds : [messageIds])
        .map((id) => String(id).trim())
        .filter(Boolean)
      const params = new URLSearchParams()
      ids.forEach((id) => params.append('messageIds', id))
      if (reason) params.append('reason', reason)
      await post(`messages/archive?${params.toString()}`)
      return ids
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const unarchiveMessage = createAsyncThunk(
  'messageArchive/unarchive',
  async ({ messageIds }, { rejectWithValue }) => {
    try {
      const ids = (Array.isArray(messageIds) ? messageIds : [messageIds])
        .map((id) => String(id).trim())
        .filter(Boolean)
      const params = new URLSearchParams()
      ids.forEach((id) => params.append('messageIds', id))
      await post(`messages/unarchive?${params.toString()}`)
      return ids
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const messageArchiveSlice = createSlice({
  name: 'messageArchive',
  initialState: {
    archivedMessageIds: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(archiveMessage.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(archiveMessage.fulfilled, (state, action) => {
        state.loading = false
        const ids = action.payload || []
        for (const id of ids) {
          if (!state.archivedMessageIds.includes(id)) {
            state.archivedMessageIds.push(id)
          }
        }
      })
      .addCase(archiveMessage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(unarchiveMessage.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(unarchiveMessage.fulfilled, (state, action) => {
        state.loading = false
        const ids = action.payload || []
        state.archivedMessageIds = state.archivedMessageIds.filter(
          (id) => !ids.includes(id)
        )
      })
      .addCase(unarchiveMessage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export default messageArchiveSlice.reducer
